// @flow

import type {Currency} from './currency';

export const MAP_PAYMENT_METHOD = {
  CONTINUE_TO_CHAT: 'Pedir por whatsapp',
  CARD: 'Tarjeta',
  OTHERS: 'Otros',
  MANUAL: 'Otros',
  PAY_ON_DELIVERY: 'Pago contra entrega',
};

export const mapPaymentMethodName = (name: string) => {
  return {
    CONTINUE_TO_CHAT: 'WhatsApp',
    CARD: 'Tarjeta',
    OTHERS: 'Otros',
    MANUAL: 'Manual',
  }[name];
};

export type SpecificPaymentMethod = {
  label: string,
  name: string,
  type: 'payment-method',
};

export type ClientParameters = {
  number?: string,
  currency?: string,
  identifier: string,
  description?: string,
  documentType?: string,
  accountNumber?: string,
  documentNumber?: string,
  internationalBankAccountNumber?: string,
};

export type PaymentMethod = {
  clientParameters: ClientParameters,
  serverParameters: {
    public_key?: string,
    secret_key?: string,
    access_token?: string,
    vads_site_id?: string,
    client_id?: string,
    client_secret?: string,
    commerce_code?: string,
    merchant_id?: string,
    username?: string,
    password?: string,
    api_key?: string,
    webhook_signatures?: {
      payment: string,
    },
  },
  currency: Currency,
  displayName: string,
  enabled: boolean,
  disabled?: boolean,
  logoId?: string,
  fileId: string,
  id: string,
  createdAt: number,
  updateAt: number,
  paymentMethod: string,
  paymentProcessor: {
    code: string,
  },
  type: 'store-payment-method-processor',
};
